'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosAmericanfootball = function IoIosAmericanfootball(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.4 10.4c8.7 8.7 6.3 25.5 6.3 25.5s-2 0.4-5.1 0.4c-5.7 0-14.8-1-20.5-6.7-8.7-8.7-6.3-25.5-6.3-25.5s2-0.4 5.1-0.4c5.7 0 14.8 1 20.5 6.7z m-24.3 4.8l0.2 1.4 11.1-11.1-1.4-0.2z m15.5 11l0.9 0.9 2.2-2.3 1.8 1.8-2.2 2.2 0.9 0.9 5.2-5.2-0.8-1-2.3 2.3-1.7-1.8 2.3-2.2-1-0.9-2.2 2.2-1.8-1.8 2.3-2.2-0.9-0.9-2.2 2.3-1.8-1.8 2.2-2.2-0.9-1-2.2 2.3-1.8-1.8 2.3-2.2-1-0.9-2.1 2.3-1.8-1.8 2.2-2.2-0.9-0.9-5.2 5.2 0.8 1 2.3-2.3 1.7 1.8-2.3 2.2 1 0.9 2.2-2.2 1.8 1.8-2.3 2.2 0.9 0.9 2.2-2.3 1.8 1.8-2.2 2.2 0.9 1 2.2-2.3 1.8 1.8z m3.9 8.5l9.9-9.9-0.2-1.4-11.1 11.1z' })
        )
    );
};

exports.default = IoIosAmericanfootball;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-americanfootball.js
// module id = 2060
// module chunks = 0